import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  rootContent: {
    marginLeft: 95,
    width: "100%",
  },
}));

export { useStyles };
